import { render, staticRenderFns } from "./vip-tab-cx-yunnan.vue?vue&type=template&id=264378c0&"
import script from "./vip-tab-cx-yunnan.vue?vue&type=script&lang=js&"
export * from "./vip-tab-cx-yunnan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports